import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import { AppRouter } from './router';
import { ConfirmHost } from './components/ui/confirm';
import './app.css';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

const container = document.getElementById('app')!;
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <SettingsProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <AppRouter />
                        <ConfirmHost />
                    </BrowserRouter>
                </AuthProvider>
            </SettingsProvider>
        </QueryClientProvider>
    </React.StrictMode>
);
